module.exports = __webpack_public_path__ + "img/start_2.155b5093.svg";